import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { OrgLeaveRoutingModule } from './org-leave-routing.module';
import { OrgLeaveComponent } from './org-leave.component';
import { OrgLeavesDetailsComponent } from './components/org-leaves-details/org-leaves-details.component';
import { OrgLeavesCreateComponent } from './components/org-leaves-create/org-leaves-create.component';
import { SharedModule } from 'src/app/shared/shared.module';


@NgModule({
  declarations: [OrgLeaveComponent, OrgLeavesDetailsComponent, OrgLeavesCreateComponent],
  imports: [
    CommonModule,
    OrgLeaveRoutingModule,
    SharedModule
  ]
})
export class OrgLeaveModule { }
